import React from "react";

import { package_boxes_modal_list } from "utils/package_boxes";

const AddItem = ({ handleAdd }) => {
  const handleFocusOnAddedFormRow = () => {
    const el = document.querySelector(
      "#packages_form .form-group:last-child .box-3:first-child input",
    );
    if (el) {
      el.select();
    }
  };
  return (
    <div className="package-boxes">
      {package_boxes_modal_list.map(({ label, items }) => (
        <div className="package-boxes__box" key={label}>
          <h3>{label}</h3>
          <ul className="box-list">
            <div className="box-list__image">
              <img
                src={require(
                  `icons/speditor-${
                    label === "Koperty" ? "envelope" : "package"
                  }.png`,
                )}
                alt="Ikona"
              />
            </div>
            <div className="box-list__wrapper">
              {items.map(({ id, name, sizes }) => (
                <li
                  className="box-list__item"
                  key={id}
                  onClick={() => {
                    handleAdd({ id, name, sizes: { ...sizes, size: id } });
                    setTimeout(() => {
                      handleFocusOnAddedFormRow();
                    }, 50);
                  }}
                >
                  <span>{name}</span>
                </li>
              ))}
            </div>
          </ul>
        </div>
      ))}
    </div>
  );
};

export default AddItem;
